/*** IMPORTS FROM imports-loader ***/
var $ = require("jquery");
var jQuery = require("jquery");

'use strict';

var d = require('../lib/dom')
  , h = require('../lib/helper')
  , instances = require('./instances');

module.exports = function (element) {
  var i = instances.get(element);

  if (!i) {
    return;
  }

  i.event.unbindAll();
  d.remove(i.scrollbarX);
  d.remove(i.scrollbarY);
  d.remove(i.scrollbarXRail);
  d.remove(i.scrollbarYRail);
  h.removePsClasses(element);

  instances.remove(element);
};




/*****************
 ** WEBPACK FOOTER
 ** ./~/perfect-scrollbar/src/js/plugin/destroy.js
 ** module id = 1531
 ** module chunks = 0
 **/